<template>
  <div class="d-flex flex-column gap-3" v-if="viewdata.type === 'filematerialityrulevel' || viewdata.type === 'filematerialitygllevel' || viewdata.type === 'filematerialitysllevel'">
    <div class="pa-2 upload-modal-card" v-for="(v,k) in Object.fromEntries(Object.entries(gldata).slice(materialityDetailsPage*25, (materialityDetailsPage+1)*25))" :key="k">
      <div class="d-flex flex-column gap-4">
        <v-row no-gutters class="align-center pa-2">
          <v-col cols="12" sm="3" class="details-label">
            Selected {{$nova.labelsName('approvals_page','ru_entity_plural_label','RUs')}}
          </v-col>
          <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
            <div class="">
              <v-chip label class="RU-Chip"><span class="noTransform RU-Chip-Text">{{viewdata.__reportingunit_detail[k].code}} - {{viewdata.__reportingunit_detail[k].name}}</span></v-chip>
            </div>
          </v-col>
        </v-row>
      </div>
      <template v-for="(vv, kk) in ['actual', 'forecast']">
        <div v-if="(gldata[k] || {})[vv]" :key="kk" class="">
          <v-pagination
            v-if="(gldata[k][vv] || []).length > itemsPerPage"
            :value="paginationState[`${k}_${vv}`] || 1"
            @input="updatePage($event, k, vv)"
            :length="Math.ceil((gldata[k][vv] || []).length / itemsPerPage)"
            :total-visible="7"
            class="upload-pagination"
          ></v-pagination>
          <lb-datatablenew class="pa-2" :headers="headers" :items="getPagedItems(gldata[k][vv], k, vv)"
          :enableslot="['gl_code_desc', 'datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional', 'management_thresholds_amount_regional', 'management_thresholds_percent_regional', 'floor_management_thresholds_regional']"
          :perpage="100">
          <template v-slot:gl_code_desc="{ item }">
            {{ item.code }} - {{ item.name }}
          </template>
          <template v-slot:datatypes=''>
            <div class='ellipsis-on text-left noTransform'>
              vs {{ proformaLabel }}
            </div>
            <div class='ellipsis-on text-left noTransform'>
              vs {{ forecastLabel }}
            </div>
          </template>
            <template v-slot:control_thresholds_amount="{ item }">
              <div class="text-right cell-input" v-if="item.control_thresholds_amount_proforma || item.control_thresholds_amount_proforma === 0">
                {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.control_thresholds_amount_forecast || item.control_thresholds_amount_forecast === 0">
                {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:control_thresholds_percent="{ item }">
              <div class="text-right cell-input" v-if="item.control_thresholds_percent_proforma || item.control_thresholds_percent_proforma === 0">
                {{ item.control_thresholds_percent_proforma || 0 }}%</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.control_thresholds_percent_forecast || item.control_thresholds_percent_forecast === 0">
                {{ item.control_thresholds_percent_forecast || 0 }}%</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:management_thresholds_amount="{ item }">
              <div class="text-right cell-input" v-if="item.management_thresholds_amount_proforma || item.management_thresholds_amount_proforma === 0">
                {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.management_thresholds_amount_forecast || item.management_thresholds_amount_forecast === 0">
                {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:management_thresholds_percent="{ item }">
              <div class="text-right cell-input" v-if="item.management_thresholds_percent_proforma || item.management_thresholds_percent_proforma === 0">
                {{ item.management_thresholds_percent_proforma || 0 }}%</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.management_thresholds_percent_forecast || item.management_thresholds_percent_forecast === 0">
                {{ item.management_thresholds_percent_forecast || 0 }}%</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:control_thresholds_amount_regional="{ item }">
              <div class="text-right cell-input" v-if="item.control_thresholds_amount_regional_proforma || item.control_thresholds_amount_regional_proforma === 0">
                {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) || item.control_thresholds_amount_proforma === 0}}</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.control_thresholds_amount_regional_forecast || item.control_thresholds_amount_regional_forecast === 0">
                {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:control_thresholds_percent_regional="{ item }">
              <div class="text-right cell-input" v-if="item.control_thresholds_percent_regional_proforma || item.control_thresholds_percent_regional_proforma === 0">
                {{ item.control_thresholds_percent_regional_proforma }}%</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.control_thresholds_percent_regional_forecast || item.control_thresholds_percent_regional_forecast === 0">
                {{ item.control_thresholds_percent_regional_forecast }}%</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:management_thresholds_amount_regional="{ item }">
              <div class="text-right cell-input" v-if="item.management_thresholds_amount_regional_proforma || item.management_thresholds_amount_regional_proforma === 0">
                {{ $nova.formatNumber(item.management_thresholds_amount_regional_proforma) }}</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.management_thresholds_amount_regional_forecast || item.management_thresholds_amount_regional_forecast === 0">
                {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
            <template v-slot:management_thresholds_percent_regional="{ item }">
              <div class="text-right cell-input" v-if="item.management_thresholds_percent_regional_proforma || item.management_thresholds_percent_regional_proforma === 0">
                {{ item.management_thresholds_percent_regional_proforma }}%</div>
              <div class="text-right cell-input" v-else>-</div>
              <div class="text-right cell-input" v-if="item.management_thresholds_percent_regional_forecast || item.management_thresholds_percent_regional_forecast === 0">
                {{ item.management_thresholds_percent_regional_forecast }}%</div>
              <div class="text-right cell-input" v-else>-</div>
            </template>
          </lb-datatablenew>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getRuHeaders, getGlHeaders } from './constants';

export default {
  name: 'ApprovalMaterialityFile',
  props: {
    viewdata: {
      type: Object,
      required: true
    },
    gldata: {
      type: Object,
      default: () => ({})
    },
    proccesed_Ru: {
      type: Array,
      default: () => []
    },
    materialityDetailsPage: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      typekeys: { "actual": "Actual", "forecast": "Forecast" },
      paginationState: {},
      itemsPerPage: 5,
    }
  },
  methods: {
    getPagedItems(items, k, vv) {
      if (!items) return [];
      const key = `${k}_${vv}`;
      const page = this.paginationState[key] || 1;
      const start = (page - 1) * this.itemsPerPage;
      return items.slice(start, start + this.itemsPerPage);
    },
    updatePage(page, k, vv) {
      const key = `${k}_${vv}`;
      this.$set(this.paginationState, key, page);
    }
  },
  computed: {
    headers() {
      if (this.viewdata.type === 'filematerialityrulevel') {
        return getRuHeaders(this);
      } else {
        return getGlHeaders(this);
      }
    },
    /**
     * Dynamic label for Actual based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    actualLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    proformaLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    forecastLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
  }
}
</script>

<style>
  .upload-modal-card {
    border: 1px solid var(--grey-300);
    border-radius: 8px;
  }
  .upload-pagination {
    width: 100%;
  }
  .upload-pagination .v-pagination {
    width: 100%;
    border-radius: var(--Space-xs, 8px);
    justify-content: flex-end !important;
  }
  .upload-pagination .v-pagination .v-pagination__item,
  .upload-pagination .v-pagination .v-pagination__navigation {
    padding: var(--space-4) var(--space-6) !important;
  }
</style>